import { render } from "./ProductsTableV2.vue?vue&type=template&id=40d02f3d&scoped=true&lang=pug"
import script from "./ProductsTableV2.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsTableV2.vue?vue&type=script&setup=true&lang=js"

import "./ProductsTableV2.vue?vue&type=style&index=0&id=40d02f3d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d02f3d"]])

export default __exports__